/**
 * View component for /admin/authoring/sites/new
 *
 * Creates a new site from a copy of the defaultItem in the site reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as siteActions from '../siteActions';
import * as siteLocationActions from '../../siteLocation/siteLocationActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyActions from '../../study/studyActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';
import routeUtils from "../../../global/utils/routeUtils";

// import site components
import SiteForm from '../components/SiteForm.js.jsx';

class AdminCreateSiteFromStudy extends Base {
  constructor(props) {
    super(props);
    this.state = {
      site: _.cloneDeep(this.props.defaultSite)
      , disabled: false
      , formHelpers: {

      }
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, location, match } = this.props;
    dispatch(sponsorActions.fetchListIfNeeded("all"));
    dispatch(siteLocationActions.fetchListIfNeeded("all"));
    dispatch(siteActions.fetchListIfNeeded('_group', match.params.studyId)); 
    dispatch(studyActions.fetchSingleIfNeeded(match.params.studyId)).then((studyAction) => {
      if(studyAction.success) {
        dispatch(studyActions.fetchListIfNeeded("_organization", studyAction.item._organization));
        dispatch(sponsorActions.fetchSingleIfNeeded(studyAction.item._organization));
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    let newSite = _.cloneDeep(this.state.site);
    if(nextProps.sponsorStore.selected && nextProps.sponsorStore.selected.id) {
      newSite._organization = nextProps.sponsorStore.selected.id;
    }
    if(nextProps.studyStore.selected && nextProps.studyStore.selected.id) {
      newSite._group = nextProps.studyStore.selected.id;
    }
    if(nextProps.location.search) {
      let searchObj = routeUtils.objectFromQueryString(nextProps.location.search)
      if(searchObj.siteNumber) {
        // console.log("add siteNumber to input")
        newSite.number = searchObj.siteNumber;
      }
    }
    this.setState({site: newSite});
  }

  _handleFormChange(e) {
    const { dispatch } = this.props;
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newSiteState = _.update( this.state.site, e.target.name, function() {
      return e.target.value;
    });
    this.setState({site: newSiteState});
    if(e.target.name === "_organization") {
      dispatch(studyActions.fetchListIfNeeded("_organization", e.target.value));
    }
  }


  _handleFormSubmit(e) {
    const { dispatch, history, match, siteStore } = this.props;
    e.preventDefault();
    this.setState({disabled: true});  
    const sites = siteStore.util.getList('_group', match.params.studyId); 
    const hasDuplicate = this.state.site.name ? sites.some(currentSite => currentSite.name.replace(' ', '').toLowerCase() == this.state.site.name.replace(' ', '').toLowerCase()) : false;
    if(!hasDuplicate) {
      dispatch(siteActions.sendCreateSite(this.state.site)).then((action) => {
        if(action.success) {
          dispatch(siteActions.invalidateList());
          dispatch(siteLocationActions.invalidateList('all')) // force refetch
  
          dispatch(siteActions.invalidateList('_group', this.state.site._group));
          // dispatch(siteLocationActions.invalidateList('_group', this.state.site._group)) // force refetch
  
          this.setState({disabled: false}); 
          history.push(`${match.url.replace('new', action.item._id)}/link-location`)
          // history.push(`/admin/authoring/sites/${action.item._id}`);
        } else {
          // console.log("Response Error:");
          // console.log(action);
          this.setState({disabled: false}); 
          alert(`ERROR: ${action.error}`);
        }
      });
    } else {
      this.setState({disabled: false}); 
      alert('OOPS! A site with this name already exists for this program.'); 
    }
  }

  render() {
    const { location, match, siteLocationStore, sponsorStore, studyStore } = this.props;
    const { site, disabled } = this.state;
    const siteLocations = siteLocationStore.util.getList() || [];
    const sponsors = sponsorStore.util.getList() || [];
    const studies = studyStore.util.getList("_organization", site._organization) || [];
    const isEmpty = (site.name === null || site.name === undefined);

    return (
      <div className="flex">
        <Helmet
          title={"Create Study Site | Pro-ficiency"}
        />
        <section className="section">
          <div className="yt-container">
            <Breadcrumbs links={location.state.breadcrumbs} />
          </div>
          { isEmpty ?
              <h2> Loading...</h2>
            :
            <div className="yt-container">
              <h2>Create a new site for the following program:</h2>
              <p><strong>Program: </strong>{studyStore.byId[site._group] && studyStore.byId[site._group].name}</p>
              <p><strong>Sponsor: </strong>{sponsorStore.byId[site._organization] && sponsorStore.byId[site._organization].name}</p>
              <SiteForm
                cancelLink={match.url.replace('/new', '')}
                disabled={disabled}
                formTitle=""
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                site={site}
                siteLocations={siteLocations}
                sponsors={sponsors}
                studies={studies}
              />
            </div>
          }
        </section>
      </div>
    )
  }
}

AdminCreateSiteFromStudy.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultSite: store.site.defaultItem
    , siteLocationStore: store.siteLocation
    , siteStore: store.site
    , sponsorStore: store.sponsor
    , studyStore: store.study
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminCreateSiteFromStudy)
);



// WEBPACK FOOTER //
// modules/site/views/AdminCreateSiteFromStudy.js.jsx